<template>
  <img
    v-bind="$attrs"
    :src="logoSrc"
    width="604"
    height="620"
    :alt="texts.brand_name_short"
    class="-img"
  />
</template>

<style scoped lang="scss">
.-img {
  display: block;
  width: auto;
  height: auto;
  aspect-ratio: 604 / 620;
}
</style>

<script setup>
defineOptions({ name: "MyLogo" });
import logoSrc from "../assets/logo.png";
import texts from "../texts.json";
</script>
